import { ModalFooter } from '@/components/Modal'

import { useController } from '../../hooks/useController'
import { ButtonApplyChanges } from './components/ButtonApplyChanges'
import { ButtonApplyChangesAndDelete } from './components/ButtonApplyChangesAndDelete'
import { ButtonCancel } from './components/ButtonCancel'
import { ButtonDelete } from './components/ButtonDelete'
import { ButtonExportAndDeleteOrders } from './components/ButtonExportAndDeleteOrders'
import { ButtonExportOrdersAndApplyChanges } from './components/ButtonExportOrdersAndApplyChanges'

export function Footer() {
  const {
    data: { isReduced, model, ordersCanBeExported },
  } = useController()

  const canExportOrDeleteOrders = isReduced && ordersCanBeExported

  const renderFooter = () => {
    switch (model) {
      case 'export':
        return (
          <ModalFooter
            primaryAction={<ButtonExportAndDeleteOrders />}
            secondaryAction={<ButtonCancel />}
          />
        )

      case 'planningRange':
        return (
          <ModalFooter
            primaryAction={
              canExportOrDeleteOrders ? (
                <ButtonExportOrdersAndApplyChanges />
              ) : (
                <ButtonApplyChanges />
              )
            }
            tertiaryAction={canExportOrDeleteOrders && <ButtonApplyChangesAndDelete />}
            secondaryAction={<ButtonCancel />}
          />
        )

      case 'delete':
        return (
          <ModalFooter
            primaryAction={<ButtonCancel isContained={true} />}
            secondaryAction={<ButtonDelete />}
          />
        )

      default:
        return null
    }
  }

  return renderFooter()
}
